<div class="chat-icon-container" (click)="toggleChat()">
    <img src="../../assets/simpli/mirai_exterior.png" class="chat-icon">
</div>

<div class="chat-container" [class.active]="chatVisible">
    <div class="chat-header">
        <p class="margin-h3">Clara, tu asistente virtual</p>
        <button mat-icon-button (click)="toggleChat()">
            <mat-icon style="color: #00022B;">close</mat-icon>
        </button>
    </div>
    <div class="chat-content add_factoring" #chatContent>
        <div class="message bot-message"  [@fadeIn]>
            <div class="avatar-img">
                <img src="../../assets/simpli/mirai_interior.png" class="avatar">
            </div>
            <div class="message-content">
                <p class="bot-name">Clara</p>
                <p class="options-title">¡Hola! ¿Qué necesitas hacer hoy?</p>
                <div class="option-container">
                    <button class="custom-btn" (click)="selectOption(4, 'Quiero simular una operación'); go_to_simular()">Quiero simular una operación</button>
                    <button class="custom-btn" (click)="selectOption(1, 'Quiero conocer los servicios')">Quiero conocer los servicios</button>
                    <button class="custom-btn" (click)="selectOption(2, '¿Como funciona el factoring?')">¿Cómo funciona el factoring?</button>
                    <button class="custom-btn" (click)="selectOption(3, '¿Dónde se ceden los documentos?')">¿Dónde ceder los documentos?</button>
                </div>
                <div class="timestamp">{{ currentDate | date:'short' }}</div>
            </div>
        </div>

        <div *ngFor="let message of userMessages; let i = index" [@fadeIn]>

            <div class="message user-message" *ngIf="i % 2 === 0">

                <div title="{{full_name}}" class="avatar-user" 
                    [ngStyle]="!isValidAvatar(avatar) ? {'background': avatarBackground} : {}">
                    <img *ngIf="isValidAvatar(avatar)" [src]="avatar" alt="User" (error)="handleAvatarError()" class="avatar-user-img"/>
                    <span *ngIf="!isValidAvatar(avatar)">{{initials}}</span>
                </div>
                
                <div class="message-content">
                    <div class="user-name">{{full_name}}</div>

                    <div class="content" [innerHTML]="message.content" *ngIf="message.type === 'text'"></div>

                    <!-- <div *ngIf="message.type === 'audio'">
                        <audio controls style="width: 100%;">
                        <source src="{{message.content}}" type="audio/wav">
                        Tu navegador no soporta audio.
                        </audio>
                    </div> -->

                    <div class="custom-audio-player" *ngIf="message.type === 'audio'">
                        <div class="audio-controls">
                            <button 
                            class="play-pause-btn"
                            (click)="toggleAudio(message.content, i)">
                            <mat-icon>{{ isAudioPlaying(i) ? 'pause' : 'play_arrow' }}</mat-icon>
                            </button>
                            
                            <div class="audio-info">
                            <div class="audio-progress-container">
                                <div class="audio-progress-bar">
                                <div 
                                    class="audio-progress-fill" 
                                    [style.width.%]="getAudioProgress(i)">
                                </div>
                                </div>
                            </div>
                            
                            <div class="audio-time">
                                <span class="current-time">{{ formatTime(currentAudioIndex === i ? currentTime : 0) }}</span>
                                <span class="total-time">{{ formatTime(currentAudioIndex === i ? duration : 0) }}</span>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="timestamp">{{ currentDate | date:'short' }}</div>

                </div>

            </div>

            <div class="message bot-message" *ngIf="i % 2 !== 0">
                <div class="avatar-img">
                    <img src="../../assets/simpli/mirai_interior.png" class="avatar">
                </div>
                <div class="message-content">
                    <p class="bot-name">Clara</p>
                    <div class="content" [innerHTML]="message.content"></div>
                    <div class="timestamp">{{ currentDate | date:'short' }}</div>
                </div>
            </div>

        </div>

        <div *ngIf="escribiendo">

            <div class="message bot-message">
                <div class="avatar-img">
                    <img src="../../assets/simpli/mirai_interior.png" class="avatar">
                </div>
                <div class="message-content">
                    <p class="bot-name">Clara</p>
                    <div>
                        <div class="typing-indicator">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <div class="chat-input">

        <input 
        id="inputclara" 
        #inputclara 
        [disabled]="disabled" 
        type="text" 
        [(ngModel)]="userMessage" 
        (keyup.enter)="sendMessage()" 
        placeholder="Escribe un mensaje..." 
        *ngIf="!isRecording">

        <div *ngIf="isRecording" class="recording-indicator">
            <div class="recording-dot"></div>
            <span class="recording-text" *ngIf="isRecording">Grabando... {{ formatRecordingTime() }}</span>
        </div>

        <button 
            *ngIf="isRecording"
            class="stop-btn" 
            (click)="stopRecording()">
            <mat-icon class="stop-icon">stop</mat-icon>
        </button>

        <button 
            [disabled]="disabled" 
            mat-icon-button (click)="sendMessage()" 
            *ngIf="hasTextInput() && !isRecording" >
            <mat-icon>send</mat-icon>
        </button>

        <button 
            *ngIf="!hasTextInput() && !isRecording" 
            class="mic-btn" 
            (click)="startRecording()" 
            mat-icon-button 
            [disabled]="disabled">
            <mat-icon>mic</mat-icon>
        </button>

    </div>

</div>

